import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { unaryRpc } from "@redotech/rpc/definition";
import z from "zod/v4";

export const hasReturnableItems = unaryRpc({
  name: "hasReturnableItems",
  input: z.object({ orderId: z.string(), returnType: z.enum(ReturnTypeEnum) }),
  output: z.boolean(),
});
